import type { LucideIcon } from 'lucide-react';
import {
  ArrowDownToLine,
  Lock,
  MinusCircle,
  RotateCcw,
  Unlock,
} from 'lucide-react';

export type WalletTransactionType =
  | 'top_up'
  | 'commission_debit'
  | 'refund_reserve'
  | 'refund_completed'
  | 'refund_release'
  | 'adjustment'
  | string;

const ICON_MAP: Record<string, { Icon: LucideIcon; tone: 'credit' | 'debit' | 'neutral' }> = {
  top_up: { Icon: ArrowDownToLine, tone: 'credit' },
  commission_debit: { Icon: MinusCircle, tone: 'debit' },
  refund_reserve: { Icon: Lock, tone: 'neutral' },
  refund_completed: { Icon: RotateCcw, tone: 'debit' },
  refund_release: { Icon: Unlock, tone: 'credit' },
  adjustment: { Icon: MinusCircle, tone: 'neutral' },
};

export function getWalletTransactionIcon(type: WalletTransactionType) {
  return ICON_MAP[type] ?? { Icon: MinusCircle, tone: 'neutral' as const };
}

export const WALLET_PERIOD_OPTIONS = [
  { value: 'all', label: 'Весь период' },
  { value: 'today', label: 'Сегодня' },
  { value: 'week', label: '7 дней' },
  { value: 'month', label: '30 дней' },
  { value: 'quarter', label: 'Квартал' },
  { value: 'year', label: 'Год' },
] as const;

export type WalletPeriod = (typeof WALLET_PERIOD_OPTIONS)[number]['value'];

export const WALLET_PAGE_SIZE = 10;
